export default __webpack_public_path__ + "static/media/quiet.1219f03c.svg";